function initializeProductCardInteractions() {
    const manualOpener = document.querySelector('.hero-banner__kit-bunch-opener');
    const productCards = document.querySelectorAll('.product-card');
    const drawerMaterial = document.querySelector('.drawer__tile-material');
    const closeButton = document.querySelector('.custom-drawer-close');
    const overlay = document.querySelector('.drawer-tile__overlay');
    const kitBunchContainer = document.querySelector('.kit-bunch__container');
    const addToCartButton = document.querySelector('.kit-bunch__add-to-cart');
    const kitBunchHeadIcon = document.querySelector('.kit-bunch__head-icon');

    if (manualOpener) {
        manualOpener.addEventListener('click', function(event) {
            event.preventDefault();
            if (kitBunchContainer) {
                kitBunchContainer.classList.add('visible', 'small');
            }
        });
    }

    if (!drawerMaterial || !kitBunchContainer || !addToCartButton || !kitBunchHeadIcon) return;

    productCards.forEach(productCard => {
        const productType = productCard.getAttribute('data-type');
        const unSelectedButton = productCard.querySelector('.product-card__un-selected');
        const selectedButton = productCard.querySelector('.product-card__selected');
        const buttonKitBunch = productCard.querySelector('.product-card__material-footer__kit-bunch');
        const opener = productCard.querySelector('.product-card__actions');
        const openerButton = productCard.querySelector('.product-card__material-footer__configure');

        if (productType === 'Kit Bunch' && (opener || openerButton)) {
            const handleClick = (e) => {
                e.preventDefault();
                handleProductCardClick(productCard, drawerMaterial);
            };

            if (opener) {
                opener.addEventListener('click', handleClick);
            }

            if (openerButton) {
                openerButton.addEventListener('click', handleClick);
            }

            if (unSelectedButton) {
                unSelectedButton.addEventListener('click', function (e) {
                    e.stopPropagation(); 
                    handleUnSelectedClick(productCard);
                });
            }

            if (selectedButton) {
                selectedButton.addEventListener('click', function (e) {
                    e.stopPropagation(); 
                    handleSelectedClick(productCard);
                });
            }

            if (buttonKitBunch) {
                buttonKitBunch.addEventListener('click', function (e) {
                    e.stopPropagation(); 
                    handleUnSelectedClick(productCard);
                });
            }
        }
    });

    if (closeButton) {
        closeButton.addEventListener('click', resetDrawer.bind(null, drawerMaterial));
    }

    if (overlay) {
        overlay.addEventListener('click', resetDrawer.bind(null, drawerMaterial));
    }

    addToCartButton.addEventListener('click', handleAddToCart.bind(null, kitBunchContainer));

    kitBunchHeadIcon.addEventListener('click', function () {
        kitBunchContainer.classList.toggle('small');
    });

    updateAddToCartButtonState();
}

function handleUnSelectedClick(productCard) {
    const variantId = productCard.getAttribute('data-handle');
    const productTitle = productCard.getAttribute('data-title');
    const variant = productCard.getAttribute('data-variant-id');
    const sku = productCard.getAttribute('data-sku');
    const imageSrc = productCard.getAttribute('data-image');

    const newItem = {
        'data-handle': variantId,
        'data-title': productTitle,
        'data-variant-id': variant,
        'data-sku': sku,
        'data-image': imageSrc
    };

    let updatedCookie = [];
    const kitBunchListCookie = Cookies.get('kitBunchListCookie');

    if (kitBunchListCookie) {
        const existingValues = JSON.parse(kitBunchListCookie);
        if (!existingValues.some(item => item['data-handle'] === variantId)) {
            if (existingValues.length < 5) {
                updatedCookie = [...existingValues, newItem];
                Cookies.set('kitBunchListCookie', JSON.stringify(updatedCookie), { expires: 7, path: '/' });
                updateMaterialContainer(newItem);
                productCard.classList.add('selected');
                const errorElement = document.querySelector('.kit-bunch__error');
                if (errorElement) {
                    errorElement.style.display = 'none';
                }
            } else {
                const errorElement = document.querySelector('.kit-bunch__error');
                if (errorElement) {
                    errorElement.style.display = 'block';
                }
                return;
            }
        }
    } else {
        updatedCookie = [newItem];
        Cookies.set('kitBunchListCookie', JSON.stringify(updatedCookie), { expires: 7, path: '/' });
        updateMaterialContainer(newItem);
        productCard.classList.add('selected');
        const errorElement = document.querySelector('.kit-bunch__error');
        if (errorElement) {
            errorElement.style.display = 'none';
        }
    }

    updateAddToCartButtonState();
}

function handleSelectedClick(productCard) {
    const variantId = productCard.getAttribute('data-handle');
    removeItemFromCookie(variantId);
    productCard.classList.remove('selected');

    const materialContainer = document.querySelector(`.kit-bunch__material-container[data-handle="${variantId}"]`);
    if (materialContainer) {
        materialContainer.setAttribute('data-handle', '');
        materialContainer.setAttribute('data-title', '');
        materialContainer.setAttribute('data-sku', '');
        materialContainer.setAttribute('data-variant-id', '');
        materialContainer.querySelector('.kit-bunch__material-title').textContent = '';
        materialContainer.querySelector('.kit-bunch__material-src').innerHTML = '';
        materialContainer.classList.remove('visible');
    }

    const kitBunchContainer = document.querySelector('.kit-bunch__container');
    if (kitBunchContainer) {
        const remainingItems = document.querySelectorAll('.kit-bunch__material-container[data-handle]');
        if (remainingItems.length === 0) {
            kitBunchContainer.classList.remove('visible');
        }
    }

    updateAddToCartButtonState();
}

function handleProductCardClick(productCard, drawerMaterial) {
    const productUrl = productCard.getAttribute('data-url');

    fetch(productUrl)
        .then(response => response.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const sectionMaterial = doc.querySelector('.section__product-material');

            if (sectionMaterial) {
                drawerMaterial.classList.add('active');
                const materialContainer = document.querySelector('.material-container-tile__content');
                if (materialContainer) {
                    materialContainer.innerHTML = sectionMaterial.innerHTML;
                    initializeMaterialPDPScripts();
                }
            }
        })
        .catch(error => {
            console.error('Errore:', error);
        });
}

function resetDrawer(drawerMaterial) {
    drawerMaterial.classList.remove('active');
    const materialContainer = document.querySelector('.material-container-tile__content');
    if (materialContainer) {
        materialContainer.innerHTML = '';
    }
}

async function handleAddToCart(kitBunchContainer) {
    const baseUrl = document.querySelector("html")?.getAttribute("data-base-url");
    const countryId = document.querySelector("html")?.getAttribute("data-country-id");
    const variantId = kitBunchContainer.getAttribute('data-master-product');
    const materialContainers = document.querySelectorAll('.kit-bunch__material-container');
    const productSections = document.querySelectorAll('.section__product-material__container');
    const productCards = document.querySelectorAll('.product-card');
    const lineItemProperties = {
        consumerUserProductId: "0",
        _extraType: "isKitBunch"
    };
    const currency = document.querySelector('html').getAttribute('data-currency');
    const language = document.querySelector('html').getAttribute('data-language');
    const materialPayloads = [];

    let counter = 1;

    materialContainers.forEach(container => {
        const dataTitle = container.getAttribute('data-title');
        const dataSku = container.getAttribute('data-sku');

        if (dataSku) {
            materialPayloads.push({
                sku: dataSku,
                quantity: 1,
                status: 10,
                attributes: []
            });

            lineItemProperties[dataTitle] = dataSku;
            counter++;
        }
    });

    const materialApiUrl = `${baseUrl}/a/ext/api/v1/consumer/products/kitBunch/fromShopify`;

    const materialHeaders = new Headers();
    materialHeaders.append("x-user-country-id", countryId);
    materialHeaders.append("x-user-currency", currency);
    materialHeaders.append("x-user-customer-id", "3");
    materialHeaders.append("x-user-language", language);
    materialHeaders.append("Content-Type", "application/json");
    materialHeaders.append("x-user-session", localStorage.getItem('shopify_session'));

    const materialRequestOptions = {
        method: "POST",
        headers: materialHeaders,
        body: JSON.stringify(materialPayloads),
        redirect: "follow"
    };

    try {
        const materialResponse = await fetch(materialApiUrl, materialRequestOptions);

        if (!materialResponse.ok) {
            const materialErrorResponse = await materialResponse.json();
            console.error(`Errore: ${JSON.stringify(materialErrorResponse)}`);
            return;
        }

        const materialData = await materialResponse.json();

        materialData.forEach((item, index) => {
            lineItemProperties[`_consumerUserId_${index + 1}`] = item.id;
        });

        const cartResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1,
                properties: lineItemProperties
            }),
        });

        if (!cartResponse.ok) {
            const cartErrorResponse = await cartResponse.json();
            throw new Error(`Errore durante l'aggiunta al carrello: ${JSON.stringify(cartErrorResponse)}`);
        }

        updateCartCounters();
        refreshCartDrawer();
        openMiniCart();
        Cookies.remove('kitBunchListCookie', { path: '/' });

        productCards.forEach(card => {
            card.classList.remove('selected');
        });

        materialContainers.forEach(container => {
            container.setAttribute('data-handle', '');
            container.setAttribute('data-title', '');
            container.setAttribute('data-sku', '');
            container.setAttribute('data-variant-id', '');
            container.querySelector('.kit-bunch__material-title').textContent = '';
            container.querySelector('.kit-bunch__material-src').innerHTML = '';
            container.classList.remove('visible');
        });

        kitBunchContainer.classList.remove('visible');

        updateAddToCartButtonState();
    } catch (error) {
        console.error(`Errore di rete: ${error}`);
    }
}

function updateMaterialContainer(item) {
    const container = document.querySelector('.kit-bunch__container');
    const materialContainer = document.querySelector(`.kit-bunch__material-container[data-handle="${item['data-handle']}"]`);

    if (!materialContainer) {
        const emptyContainer = document.querySelector('.kit-bunch__material-container[data-handle=""]');
        if (emptyContainer) {
            emptyContainer.setAttribute('data-handle', item['data-handle']);
            emptyContainer.setAttribute('data-title', item['data-title']);
            emptyContainer.setAttribute('data-sku', item['data-sku']);
            emptyContainer.setAttribute('data-variant-id', item['data-variant-id']);
            emptyContainer.querySelector('.kit-bunch__material-title').textContent = item['data-title'];
            emptyContainer.querySelector('.kit-bunch__material-src').innerHTML = `<img src="${item['data-image']}" alt="${item['data-title']}">`;
            emptyContainer.classList.add('visible');

            const removeButton = emptyContainer.querySelector('.kit-bunch__material-remove');
            removeButton.addEventListener('click', function () {
                removeItemFromCookie(item['data-handle']);
                emptyContainer.setAttribute('data-handle', '');
                emptyContainer.setAttribute('data-title', '');
                emptyContainer.setAttribute('data-sku', '');
                emptyContainer.setAttribute('data-variant-id', '');
                emptyContainer.querySelector('.kit-bunch__material-title').textContent = '';
                emptyContainer.querySelector('.kit-bunch__material-src').innerHTML = '';
                emptyContainer.classList.remove('visible');

                document.querySelector(`.section__product-material__container[data-handle="${item['data-handle']}"]`)?.classList.remove('selected');
                document.querySelector(`.product-card[data-handle="${item['data-handle']}"]`)?.classList.remove('selected');

                updateAddToCartButtonState();
            });
        }
    }

    if (container) {
        container.classList.add('visible');
    }
}

function removeItemFromCookie(handle) {
    const kitBunchListCookie = Cookies.get('kitBunchListCookie');
    if (kitBunchListCookie) {
        const updatedValues = JSON.parse(kitBunchListCookie).filter(item => item['data-handle'] !== handle);
        if (updatedValues.length > 0) {
            Cookies.set('kitBunchListCookie', JSON.stringify(updatedValues), { expires: 7, path: '/' });
        } else {
            Cookies.remove('kitBunchListCookie', { path: '/' });
        }
    }
}

function updateAddToCartButtonState() {
    const kitBunchListCookie = Cookies.get('kitBunchListCookie');
    const addToCartButton = document.querySelector('.kit-bunch__add-to-cart');

    if (addToCartButton) {
        if (!kitBunchListCookie || JSON.parse(kitBunchListCookie).length === 0) {
            addToCartButton.disabled = true;
        } else {
            addToCartButton.disabled = false;
        }
    }
}

initializeProductCardInteractions();